<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-13 10:21:22
 * @最后编辑: Betway
 * @最后修改时间: 2022-01-10 11:14:50
-->
<template>
  <mrc_ess_skeleton_loader
    :loading="$store.state.uuid ? skeletonloading : false"
  >
    <mrc_ess_iconGroup
      :is_disabled="disabled"
      :showEdit="hasBtn('edit-push-message-topic')"
      :show_del="hasBtn('delete-push-message-topic')"
      :showReturn="false"
      @handleEdit="handleEdit"
      @handleDel="handleDel"
    ></mrc_ess_iconGroup>
    <v-card>
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="6">
            <mrc_ess_multiText
              :label="$t('label_Topic_name') + '*'"
              :isNational="judegNational('topic_name')"
              :readonly="disabled"
              :error-messages="
                $errors('list', 'topic_name', requiredRule.concat(nocharacter))
              "
              v-model="list.topic_name"
            >
            </mrc_ess_multiText>
          </v-col>

          <v-col cols="12" sm="6">
            <mrc_ess_multiText
              :label="$t('label_describe') + '*'"
              :error-messages="
                $errors(
                  'list',
                  'topic_description',
                  requiredRule.concat(nocharacter)
                )
              "
              :isNational="judegNational('topic_description')"
              :readonly="disabled"
              v-model="list.topic_description"
            >
            </mrc_ess_multiText>
          </v-col>
          <v-col cols="12" sm="12" v-if="$store.state.uuid">
            <span class="text-h6 ma-1">{{
              $t("label_topic_and_staff_relationship")
            }}</span>
            <RelaShip :disabled="disabled" @delete="onDelete" />
          </v-col>
        </v-row>
      </v-card-text>
      <template v-if="$store.state.uuid">
        <mrc_ess_submitBtn
          @cancel="cancel"
          :loading="loading"
          @success="success"
          v-if="!disabled"
        ></mrc_ess_submitBtn>
      </template>
      <template v-else>
        <mrc_ess_submitBtn
          @cancel="addcancel"
          @success="addsuccess"
          v-if="!disabled"
        ></mrc_ess_submitBtn>
      </template>
    </v-card>
  </mrc_ess_skeleton_loader>
</template>

<script>
import {
  getMessageTopicDetail,
  updateMessageTopicDetail,
  deleteMessageTopicMap,
  deleteMessageTopicDetail,
} from "@/service/api/pushMessageTopic";
import RelaShip from "./relaship.vue";
import { required } from "vuelidate/lib/validators";
export default {
  components: { RelaShip },
  props: {
    disabled: {
      type: Boolean,
    },
  },
  data() {
    return {
      skeletonloading: true,
      deleteArr: [],
      list: {},
      loading: false,
    };
  },
  computed: {},
  created() {},
  watch: {},
  async mounted() {
    this.national("mrbase_sys_message_push_topic");
    const uuid = this.$route.params.uuid || this.$store.state.uuid;
    if (uuid) {
      await this.getdetail();
      if (!this.$store.state.iconstatus) {
        // this.$emit("changeReadonly");
        this.$store.commit("set_iconstatus", false);
      }
    } else {
    }
  },

  methods: {
    onDelete(e) {
      this.deleteArr.push(e);
    },
    getData(val) {
      this.$set(this.list, "function_uuid", "");
    },
    async getdetail() {
      this.skeletonloading = true;
      const res = await getMessageTopicDetail({
        uuid: this.$store.state.uuid,
      });
      if (res.code == 200) {
        // this.$store.commit('set_subPage_name', res.data.topic_name)
        this.list = res.data;
        this.skeletonloading = false;
      }
    },
    async cancel() {
      await this.getdetail();
      this.$emit("changeReadonly");
    },
    async success() {
      this.$v.list.$touch();
      if (this.$v.list.$error) return;
      this.loading = true;
      if (this.deleteArr.length) {
        await deleteMessageTopicMap({ uuids: this.deleteArr.join(",") }).then(
          () => {
            this.deleteArr = [];
          }
        );
      }
      await updateMessageTopicDetail(this.$deletefield(null, this.list)).then(
        (res) => {
          if (res.code == 200) {
            this.getdetail();
            this.$emit("changeReadonly");
            this.$emit("changeFunctionUuid");
            this.$Message({
              text: this.$t("message_The_operation_was_successful"),
            });
          }
        }
      );
      this.loading = false;
    },
    addcancel() {
      this.$myConfirm({
        content: this.$t("message_Confirm_the_cancellation_of_the_edit"),
      })
        .then((res) => {
          this.$router.push({
            name: "pushMessageTopic",
          });
        })
        .catch((err) => {});
    },
    addsuccess() {
      this.$v.list.$touch();
      if (this.$v.list.$error) return;
      this.$emit("add", this.list);
    },
    handleEdit() {
      this.$emit("changeReadonly");
      this.$store.commit("set_iconstatus", this.readonly);
    },
    handleDel() {
      this.$myConfirm({
        content: this.$t("message_Confirm_the_deletion"),
      }).then((res) => {
        deleteMessageTopicDetail({ uuids: this.$store.state.uuid }).then(
          (res) => {
            if (res.code == 200) {
              this.$Message({
                text: this.$t("message_The_deletion_was_successful"),
              });
              this.$router.push({
                name: "pushMessageTopic",
                params: {
                  type: "del",
                },
              });
            }
          }
        );
      });
    },
  },
  validations: {
    list: {
      topic_name: {
        required,
        nocharacter(value) {
          return this.$myVerify.nocharacter(this.INT(value));
        },
      },

      topic_description: {
        required,
        nocharacter(value) {
          return this.$myVerify.nocharacter(this.INT(value));
        },
      },
    },
  },
};
</script>

